import React from 'react'
import { Image } from "@chakra-ui/react"

const LogoWordMark = ({ w = "84px", ...props }) => {
    return <Image src="https://ik.imagekit.io/splitgeniemedia/assets/SplitGenie_Beta_1__IF6KNkl1J.svg" w={w} {...props} />
}

export default LogoWordMark
